var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { call } from 'app/utils/function';
const promptResolveMap = {};
const promptResult = createAsyncThunk('project/prompt/result', (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { id, result } = params;
    const info = promptResolveMap[id];
    if (info) {
        call(info.resolve, result);
    }
    delete promptResolveMap[id];
}));
const showPrompt = createAsyncThunk('project/prompt', (params, { requestId }) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield new Promise(resolve => {
        promptResolveMap[requestId] = { startedAt: Date.now(), resolve };
    });
    return result;
}));
export const Prompt = { show: showPrompt, close: promptResult };
